export default __webpack_public_path__ + "static/media/dashboard.51d97a9e.png";